// jshint esversion: 8

export default {
  id: state => state.id,
  location: state => state.location,
  name: state => state.name,
  operator: state => state.operator
}
